import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './paper.style.js'


export const paperVariants = ['primary', 'secondary', 'error', 'info', 'success', 'warning'] as const
export type PaperVariant = typeof paperVariants[number]

export const paperSizes = ['default', 'large', 'extraLarge'] as const
export type PaperSize = typeof paperSizes[number]

@customElement('csc-paper')
export class CSCPaper extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  variant: PaperVariant = 'secondary'

  @property({ type: Boolean })
  bordered = false

  @property({ type: String })
  size: PaperSize = 'default'

  override render() {
    return html`
      <cse-paper variant="${this.variant}" ?bordered="${this.bordered}" size="${this.size}">
        <slot name="heading" slot="heading"></slot>
        <slot></slot>
      </cse-paper>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-paper': CSCPaper
  }
}
